import React, { Component } from "react";
import "./App.css";
import firebase from "firebase";
import Header from "./components/Header";
import GoogleAds from "./GoogleAds";
import TotalVotes from "./components/TotalVotes";
import BudgetVote from "./components/BudgetVote";
import Comment from "./components/Comment";
import Footer from "./components/Footer";
import FooterCredits from "./components/FooterCredits";

var firebaseConfig = {
  apiKey: "AIzaSyB0tATlNzZYEIK7iAyrHoQISwXsWPerBFw",
  authDomain: "budget-voting-poll.firebaseapp.com",
  databaseURL: "https://budget-voting-poll.firebaseio.com",
  projectId: "budget-voting-poll",
  storageBucket: "budget-voting-poll.appspot.com",
  messagingSenderId: "696737071712",
  appId: "1:696737071712:web:e457051c27bebc3edc3905"
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const increment = firebase.firestore.FieldValue.increment(1);
const collection = "budget2020";

const CardsIcon01 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_01.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon02 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_02.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon03 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_03.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon04 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_04.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon05 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_05.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon06 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_06.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon07 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_07.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon09 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_09.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon10 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_10.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon11 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_11.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon12 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_12.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon13 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_13.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon14 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_14.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon15 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_15.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon16 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_16.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};

const voteQuest = [
  {
    id: "budget-2020-card-01",
    title: "Gaji minimum di bandar utama dinaikkan",
    descr: "Bermula 2020, gaji minimum di bandar utama dinaikkan daripada RM1,100 kepada RM1,200",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon01 />
  },
  {
    id: "budget-2020-card-02",
    title: "Tambahan tempoh cuti bersalin",
    descr: "Tempoh cuti bersalin ditambah daripada 60 kepada 90 hari, bermula 2021.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon02 />
  },
  {
    id: "budget-2020-card-03",
    title: "Tingkatkan kebajikan masyarakat Felda",
    descr: "Kerajaan memperuntukkan RM810 juta termasuklah untuk program meningkatkan pendapatan, hapus kira faedah pinjaman, perumahan dan infrastruktur asas.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon03 />
  },
  {
    id: "budget-2020-card-04",
    title: "Harga minimum untuk warga asing memiliki hartanah diturunkan",
    descr: "Warga asing kini boleh membeli hartanah berharga minimum RM600,000 berbanding RM1 juta sebelum ini bagi kurangkan lebihan bekalan.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon04 />
  },
  {
    id: "budget-2020-card-05",
    title: "Kadar cukai lebih tinggi untuk golongan mewah",
    descr: "Golongan berpendapatan boleh cukai melebihi RM2 juta setahun akan dikenakan cukai 30 peratus, kenaikan 2 peratus.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon05 />
  },
  {
    id: "budget-2020-card-06",
    title: "Cukai untuk perkhidmatan digital",
    descr: "Cukai Perkhidmatan Digital akan dikenakan akan bermula pada 1 Jan 2020.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon06 />
  },
  {
    id: "budget-2020-card-07",
    title: "Insentif untuk graduan menganggur yang diambil bekerja",
    descr: "Graduan menganggur yang diambil bekerja, dan majikannya menerima masing-masing RM500 dan RM300 sebulan dalam tempoh dua tahun.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon07 />
  },
  {
    id: "budget-2020-card-09",
    title: "Kadar tol lebih rendah untuk lebuh raya PLUS",
    descr: "Tol lebuh raya di bawah PLUS akan diberi diskaun 18 peratus. Tarikh pelaksanaan belum diumumkan.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon09 />
  },
  {
    id: "budget-2020-card-10",
    title: "Subsidi vaksin untuk kanak-kanak",
    descr: "RM60 juta diperuntukkan untuk vaksin pneumococcal, bernilai RM325 sedos di klinik swasta. Vaksin itu memerlukan dua dos.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon10 />
  },
  {
    id: "budget-2020-card-11",
    title: "Menyelesaikan isu Tambak Johor-Singapura",
    descr:
      "Kerajaan akan melabur RM85 juta bermula 2020 untuk melancarkan aliran trafik khususnya yang melalui Kompleks Kastam, Imigresen dan Kuarantin (CIQ), selain menyelesaikan isu kesesakan sepanjang Tambak Johor-Singapura.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon11 />
  },
  {
    id: "budget-2020-card-12",
    title: "Menarik pelaburan China",
    descr: "Saluran Khas bagi menarik pelaburan dari China akan ditubuhkan di bawah InvestKL, bagi memastikan pelaburan dari China setara dengan AS.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon12 />
  },
  {
    id: "budget-2020-card-13",
    title: "Subsidi minyak RON95 merangkumi bukan penerima BSH",
    descr:
      "Golongan layak, akan diberi Kad95 yang membolehkan pemegang termasuk bukan penerima BSH menikmati subsidi petrol 30 sen per liter terhad kepada 100 liter sebulan bagi kereta atau 40 liter sebulan bagi motosikal.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon13 />
  },
  {
    id: "budget-2020-card-14",
    title: "Kategori penerima BSH diluaskan",
    descr: "Jumlah bayaran BSH kekal, namun diluaskan kepada golongan OKU berumur 18 tahun ke atas dan bujang berumur 40 ke atas berpendapatan RM2,000 ke bawah.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon14 />
  },
  {
    id: "budget-2020-card-15",
    title: "Dana E-sukan dinaikkan sekali ganda",
    descr: "Dana untuk e-suka dinaikkan kepada RM20 juta susulan 'potensi tinggi' industri itu.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon15 />
  },
  {
    id: "budget-2020-card-16",
    title: "Pengurangan jumlah Cabutan Khas Operator Nombor Ramalan",
    descr:
      "Mulai 2020, jumlah Cabutan Khas yang dibuat oleh Operator Nombor Ramalan akan dikurangkan daripada 11 kepada lapan kali cabutan setahun. Turut dicadangkan penalti mandatori minimum RM100 ribu untuk penjudi haram dan  RM1 juta pengendali perjudian haram.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon16 />
  }
];

class App extends Component {
  constructor() {
    super();
    this.state = {
      voteCards: [],
      isLoading: true,
      isUserVoted: null,
      totalActionCount: 0,
      totalAverageLikesCount: 0,
      totalAverageDislikesCount: 0
    };
  }

  componentDidMount = async () => {
    (function() {
      let d = document,
        s = d.createElement("script");
      s.src = "https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-55378495366fd469";
      (d.head || d.body).appendChild(s);
    })();

    const clonedQuest = [...voteQuest];

    const newVoteQuest = clonedQuest.map(item => {
      const getLock = localStorage.getItem(`${item.id}-lock`);
      console.log(getLock);
      let isVoted = getLock === "1";
      console.log(isVoted);
      item.isVoted = isVoted;
      return item;
    });

    const allVotesDataPromise = [];

    newVoteQuest.map(item => {
      const newFetch = db
        .collection("budget2020")
        .doc(item.id)
        .get();
      allVotesDataPromise.push(newFetch);
      return null;
    });

    const allVotesDataSnapshots = await Promise.all(allVotesDataPromise);

    const allVotesData = {};
    newVoteQuest.map((item, index) => {
      allVotesData[item.id] = allVotesDataSnapshots[index].data();
      return null;
    });

    const finalVoteQuest = newVoteQuest.map(item => {
      const voteData = allVotesData[item.id];
      item.likes = voteData.likes || 0;
      item.dislikes = voteData.dislikes || 0;
      return item;
      // item.likes = voteData.likes || 0;
    });

    console.log(finalVoteQuest);

    this.setState({ voteCards: newVoteQuest, isLoading: false }, () => {
      this.calculateAllActions();
    });
  };

  calculateAllActions = () => {
    const { voteCards } = this.state;
    let actionCount = 0;
    let averageLikesCount = 0;
    let averageDislikesCount = 0;
    voteCards.map(item => {
      const { likes, dislikes } = item;
      const totalItemCount = likes + dislikes;
      actionCount = actionCount + totalItemCount;
      averageLikesCount = parseInt((likes / totalItemCount) * 100);
      averageDislikesCount = parseInt((dislikes / totalItemCount) * 100 + 1);
      return null;
    });

    this.setState({ totalActionCount: actionCount });
    this.setState({ totalAverageLikesCount: averageLikesCount });
    this.setState({ totalAverageDislikesCount: averageDislikesCount });
  };

  updateCurrentCounts = async () => {
    const clonedQuest = [...voteQuest];
    const allVotesDataPromise = [];

    clonedQuest.map(item => {
      const newFetch = db
        .collection("budget2020")
        .doc(item.id)
        .get();
      allVotesDataPromise.push(newFetch);
      return null;
    });

    const allVotesDataSnapshots = await Promise.all(allVotesDataPromise);

    const newClone = clonedQuest.map((item, index) => {
      const countForThisItem = allVotesDataSnapshots[index].data();
      item.likes = countForThisItem.likes;
      item.dislikes = countForThisItem.dislikes;
      return item;
    });

    this.setState({ voteQuest: newClone });
  };

  // voteCards = voteQuest[0];

  lockUser = itemId => {
    localStorage.setItem(`${itemId}-lock`, "1");
  };

  updateUserIsVoted = itemId => {
    const clonedVoteCards = [...this.state.voteCards];
    console.log(clonedVoteCards);
    const newVoteCards = clonedVoteCards.map(item => {
      if (item.id === itemId) {
        item.isVoted = true;
      }
      return item;
    });
    this.setState({ voteCards: newVoteCards }, () => {
      this.calculateAllActions();
    });
  };

  handleLikeEvent = async itemId => {
    try {
      await db
        .collection(collection)
        .doc(itemId)
        .update({ likes: increment });
      this.lockUser(itemId);
      this.updateUserIsVoted(itemId);
      this.updateCurrentCounts();
      console.log("DONE!");
    } catch (error) {
      console.log(error);
    }
  };

  handleDislikeEvent = async itemId => {
    try {
      await db
        .collection(collection)
        .doc(itemId)
        .update({ dislikes: increment });
      this.lockUser(itemId);
      this.updateUserIsVoted(itemId);
      this.updateCurrentCounts();
      console.log("DONE!");
    } catch (error) {
      console.log(error);
    }
  };

  handleEvent = voteCardId => {
    const updatedVoteQuest = this.state.voteCards.map(voteCards => {
      if (voteCards.id === voteCardId) {
        return Object.assign({}, voteCards, {
          votes: voteCards.votes + 1
        });
      } else {
        return voteCards;
      }
    });

    this.setState({
      members: updatedVoteQuest
    });
  };

  render() {
    return (
      <>
        <Header />
        <section className="uk-section uk-padding-remove-top">
          <div className="uk-container uk-container-small">
          <TotalVotes totalActionCount={this.state.totalActionCount} totalAverageLikesCount={this.state.totalAverageLikesCount} totalAverageDislikesCount={this.state.totalAverageDislikesCount} />
            <ul className="uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-text-center uk-grid-match uk-grid" uk-height-match="target: > li > .uk-card > .uk-card-body" uk-grid=" ">
              {!this.state.isLoading &&
                this.state.voteCards.map(voteCard => (
                  <BudgetVote
                    key={voteCard.id}
                    id={voteCard.id}
                    title={voteCard.title}
                    descr={voteCard.descr}
                    likes={voteCard.likes}
                    dislikes={voteCard.dislikes}
                    onVoteLike={this.handleLikeEvent}
                    onVoteDislike={this.handleDislikeEvent}
                    isUserVoted={voteCard.isVoted}
                    icon={voteCard.icon}
                    totalActions={voteCard.likes}
                  />
                ))}
            </ul>
          </div>
          <div className="uk-container uk-flex uk-flex-center uk-margin-large uk-light">
            <div>
              <p className="uk-text-small uk-text-uppercase uk-margin-small" style={{ fontSize: "10px", letterSpacing: "2px" }}>
                Iklan
              </p>
              <div id="ad-slot"></div>
              </div>
            <GoogleAds />
          </div>
        </section>
        <Comment />
        <Footer />
        <FooterCredits />
      </>
    );
  }
}

export default App;
